import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, apiErr } from "@/lib/api";
import { Logo, Button, Input } from "@/lib/ui";
import { useAuth } from "@/context/Auth";

export default function BuyerEntry() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/buyer/enter", { phone });
      setToken(data.token);
      setUser(data.user);
      nav("/buyer/city");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white p-8 fade-up">
        <Logo />
        <h1 className="mt-6 font-head text-2xl font-extrabold text-slate-900">Enter your phone number</h1>
        <p className="mt-1 text-sm text-slate-500">Quick access — no OTP needed for this preview.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="flex items-center gap-2 rounded-lg border border-slate-300 px-3 focus-within:border-orange-500 focus-within:ring-2 focus-within:ring-orange-100">
            <span className="text-sm font-semibold text-slate-500">+91</span>
            <input
              data-testid="buyer-phone-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
              placeholder="Phone Number"
              className="w-full border-0 py-2.5 text-sm outline-none"
              inputMode="numeric"
            />
          </div>
          <Button data-testid="buyer-continue-btn" type="submit" disabled={loading} className="w-full">
            {loading ? "Please wait…" : "Continue"} <i className="fa-solid fa-arrow-right" />
          </Button>
        </form>
        <button onClick={() => nav("/")} className="mt-4 text-xs font-semibold text-slate-400 hover:text-slate-600">
          <i className="fa-solid fa-chevron-left mr-1" /> Back
        </button>
      </div>
    </div>
  );
}
